import EkgRecording from './EkgRecording';

export default EkgRecording;
